import { render } from "./TipoAgendamentoSelect.vue?vue&type=template&id=74bd3e4a"
import script from "./TipoAgendamentoSelect.vue?vue&type=script&lang=js"
export * from "./TipoAgendamentoSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__